<!-- TODO: fix this so we don't embed the svg as image, but inline it so we can target it with css and change colors -->
<img [src]="src" />
